import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetAllDataGroups = async (idCenter, idRole, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            idUserRol: idRole
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetGroupsByInstructor"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetGroupsByInstructor", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()

        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetAllDataGroups DL Groups', error)
        return { success: false, message: 'No ha sido posible obtener el listado de grupos. Intenta actualizar la página o intenta actualizarla más tarde.' }
    }
}

const GetZtudentsOfGroup = async (idGroup, token) => {
    try {
        const dataToSend = {
            idGroup: idGroup
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        
        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetGroupZtudiantes"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetGroupZtudiantes", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetZtudentsOfGroup DL Groups', error)
        return { success: false, message: 'No ha sido posible obtener el listado de grupos. Intenta actualizar la página o intenta actualizarla más tarde.' }
    }
}

const GetZtudentGroups = async (idZtudiante, idCenter, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetZtudianteGroups"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetZtudianteGroups", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetZtudentGroups DL Groups', error)
        return { success: false, message: 'No ha sido posible obtener el listado de grupos. Intenta actualizar la página o intenta actualizarla más tarde.' }
    }
}

const CreateGroup = async (groupName, idCenter, idRole, token) => {
    try {
        const dataToSend = {
            groupName: groupName,
            idCenter: idCenter,
            idUserRol: idRole
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/CreateGroup"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/CreateGroup", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('CreateGroup DL Groups', error)
        return { success: false, message: 'No ha sido posible crear el grupo. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeleteGroup = async (idGroup, token) => {
    try {
        const dataToSend = {
            idGroup: idGroup
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/DeleteGroup"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/DeleteGroup", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })

        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }

        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('DeleteGroup DL Groups', error)
        return { success: false, message: 'No ha sido posible crear el grupo. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const ShowGroup = async (idGroup, token) => {
    try {
        const dataToSend = {
            idGroup: idGroup
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ShowGroupZtudiantes"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/ShowGroupZtudiantes", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('ShowGroup DL Groups', error)
        return { success: false, message: 'No ha sido posible mostrar el grupo. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const HideGroup = async (idGroup, token) => {
    try {
        const dataToSend = {
            idGroup: idGroup
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/HideGroupZtudiantes"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/HideGroupZtudiantes", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('HideGroup DL Groups', error)
        return { success: false, message: 'No ha sido posible ocultar el grupo. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}


//----- Group -----//

const AcceptZtudent = async (idZtudiante, idGroup, idCenter, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idGroup: idGroup,
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/AcceptZtudiante"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/AcceptZtudiante", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('AcceptZtudent DL Groups', error)
        return { success: false, message: 'No ha sido posible aceptar al Ztudiante. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const RejectZtudent = async (idZtudiante, idGroup, idCenter, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idGroup: idGroup,
            idCenter: idCenter
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/RejectZtudiante"
        
        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/RejectZtudiante", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('RejectZtudent DL Groups', error)
        return { success: false, message: 'No ha sido posible eliminar al Ztudiante. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeleteZtudentOfGroup = async (idZtudiante, idGroup, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idGroup: idGroup
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/DeleteZtudianteFromGroup"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/DeleteZtudianteFromGroup", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('DeleteZtudentOfGroup DL Groups', error)
        return { success: false, message: 'No ha sido posible eliminar al Ztudiante. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const HideZtudent = async (idZtudiante, idGroup, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idGroup: idGroup
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/HideSingleZtudiante"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/HideSingleZtudiante", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('HideZtudent DL Groups', error)
        return { success: false, message: 'No ha sido posible ocultar al Ztudiante. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const ShowZtudent = async (idZtudiante, idGroup, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idGroup: idGroup
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ShowSingleZtudiante"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/ShowSingleZtudiante", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('ShowZtudent DL Groups', error)
        return { success: false, message: 'No ha sido posible mostrar al Ztudiante. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

//----- Group -----//

//--- Groups Common ---//

const RenameGroup = async (idGroup, newGroupName, idCenter, role, token) => {
    try {
        const dataToSend = {
            idGroup: idGroup,
            newGroupName: newGroupName,
            idCenter: idCenter,
            idUserRol: role
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        
        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/UpdateNameGroup"
        
        const response = await DoubleAttempt(url, parameters, false)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('RenameGroup DL Groups', error)
        return { success: false, message: `No ha sido posible renombrar el grupo. Inténtalo nuevamente o inténtalo más tarde.` }
    }
}

//--- Groups Common ---//

export { GetAllDataGroups, GetZtudentsOfGroup, GetZtudentGroups, CreateGroup, DeleteGroup, ShowGroup, HideGroup, AcceptZtudent, RejectZtudent, DeleteZtudentOfGroup, HideZtudent, ShowZtudent, RenameGroup };